module.exports = __webpack_public_path__ + "static/media/editasset.239d80e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/portfolio/assetperiscope/editasset.png
// module id = 246
// module chunks = 0